import React from 'react';
import { HyperlinkMarkup } from './Hyperlink.style';
/**
 * @deprecated Depricate in favour of Link form @next-common/mui
 */
export const Hyperlink = (props) => {
    const { children, href, openLinkInNewTab = false, extraClassName = '', onClick, noFollow = false } = props;
    const dynamicProps = {};
    if (openLinkInNewTab) {
        dynamicProps.target = '_blank';
        dynamicProps.rel = 'noopener noreferrer';
    }
    if (noFollow) {
        if (dynamicProps.rel) {
            dynamicProps.rel += ' nofollow';
        }
        else {
            dynamicProps.rel = 'nofollow';
        }
    }
    return (React.createElement(HyperlinkMarkup, Object.assign({ color: props.color, fontSize: props.fontSize, className: `${extraClassName}`, href: href, extraStyles: props.extraStyles }, dynamicProps, { onClick: onClick, "data-qa": "hyperlink" }), children));
};
